import { GlDisclosureDropdownItem, GlIcon, GlSearchBoxByType, GlToggle } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { InternalEvents } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import { applicableMetadataFields, persistMetadataPreference, alertPreferenceError } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/list/display_settings_preferences.js?vue3';
export default {
    name: 'WorkItemDisplaySettingsMetadata',
    components: {
        GlDisclosureDropdownItem,
        GlIcon,
        GlSearchBoxByType,
        GlToggle
    },
    mixins: [
        InternalEvents.mixin()
    ],
    i18n: {
        fields: s__('WorkItems|Fields'),
        shown: s__('WorkItems|Shown'),
        hidden: s__('WorkItems|Hidden'),
        searchPlaceholder: s__('WorkItems|Search fields'),
        noFieldsFound: s__('WorkItems|No fields match your search.')
    },
    props: {
        workItemTypeId: {
            type: String,
            required: true
        },
        sortKey: {
            type: String,
            required: true
        },
        fullPath: {
            type: String,
            required: true
        },
        namespacePreferences: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        isServiceDeskList: {
            type: Boolean,
            required: false,
            default: false
        },
        isSavedView: {
            type: Boolean,
            required: false,
            default: false
        },
        viewMode: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: [
        'update-settings'
    ],
    data () {
        return {
            searchQuery: ''
        };
    },
    computed: {
        hiddenMetadataKeys () {
            return this.namespacePreferences?.hiddenMetadataKeys || [];
        },
        applicableMetadataPreferences () {
            return applicableMetadataFields({
                isServiceDeskList: this.isServiceDeskList,
                viewMode: this.viewMode
            });
        },
        filteredMetadataPreferences () {
            const query = this.searchQuery.trim().toLowerCase();
            if (!query) return this.applicableMetadataPreferences;
            return this.applicableMetadataPreferences.filter((item)=>item.label.toLowerCase().includes(query));
        },
        shownPreferences () {
            return this.filteredMetadataPreferences.filter((item)=>!this.hiddenMetadataKeys.includes(item.key));
        },
        hiddenPreferences () {
            return this.filteredMetadataPreferences.filter((item)=>this.hiddenMetadataKeys.includes(item.key));
        },
        noFieldsAvailable () {
            return this.filteredMetadataPreferences.length === 0;
        }
    },
    methods: {
        async toggleMetadataDisplaySettings (metadataKey) {
            const wasHidden = this.hiddenMetadataKeys.includes(metadataKey);
            const newHiddenKeys = wasHidden ? this.hiddenMetadataKeys.filter((key)=>key !== metadataKey) : [
                ...this.hiddenMetadataKeys,
                metadataKey
            ];
            const input = {
                ...this.namespacePreferences,
                hiddenMetadataKeys: newHiddenKeys
            };
            if (this.isSavedView) {
                this.$emit('update-settings', input);
                if (!wasHidden) {
                    this.trackEvent('work_item_metadata_field_hidden', {
                        property: metadataKey
                    });
                }
                return;
            }
            try {
                await persistMetadataPreference({
                    apolloClient: this.$apollo,
                    namespace: this.fullPath,
                    workItemTypeId: this.workItemTypeId,
                    userPreferencesOnly: this.isSavedView,
                    displaySettings: input,
                    sort: this.sortKey
                });
                if (!wasHidden) {
                    this.trackEvent('work_item_metadata_field_hidden', {
                        property: metadataKey
                    });
                }
            } catch (error) {
                alertPreferenceError(error);
            }
        }
    }
};
